import { replySnippets } from '../replySnippet'
import { describeTable } from './describeTable'

describeTable(replySnippets, {
  description:
    'Reusable reply templates (vastauspohjat) reps insert into the inbox reply editor and the quick email composer by typing "/" + shortcut. usage_count and last_used_at show which templates are actually used. owner_user_id NULL = shared with the whole team, otherwise private to that rep. Small table.',
  columns: {
    shortcut: "Slash keyword that picks the snippet, e.g. 'seuranta'.",
    body: 'Template text with client-rendered placeholders like {etunimi}.',
    ownerUserId: 'NULL = team-wide; set = visible only to that user.',
    usageCount: 'Times inserted into a reply.',
    lastUsedAt: 'Last insertion.',
  },
})
